import * as BaseService from '@/services/BaseService'

const getConstObj = function(){
  const constObj = sessionStorage.getItem('const_obj')
  if(constObj !== null){
    return JSON.parse(constObj)
  }
  return null
}

let constants = {
  MAX_UPLOAD_SIZE: getConstObj()?.MAX_UPLOAD_SIZE,
  PAGE_SIZE: getConstObj()?.PAGE_SIZE,
  IMAGE_BASEURL:'https://d16511ywy1aud9.cloudfront.net',
  IMAGE_TYPE: getConstObj()?.IMAGE_TYPE,
  ROLE_ID:{
    SYS_CHIEF_ADMIN:'1',
    SYS_ADMIN:'2',
    MER_CHIEF_ADMIN:'3',
    MER_ADMIN:'4',
    MER_KEEPER:'5',
    MER_TREASUER:'6',
    USER:'7',
  },
  CURRENCY:getConstObj()?.CURRENCY,
  USER_AVATAR_IMG:'userAvatarImg',
  RATE_IMG_IMG:'rateImg',
  BASEURL:getConstObj()?.BASEURL,
  CANCELTIME:getConstObj()?.CANCELTIME,
  REVIEWTIME:getConstObj()?.REVIEWTIME
}

const ConstantsPlugin = {
  install(Vue) {
    Vue.prototype.$constants = constants
  }
}

const loadData = function(){
  if(constants.MAX_UPLOAD_SIZE !== null && typeof(constants.MAX_UPLOAD_SIZE) !== 'undefined'){
    return
  }
  BaseService.getBaseData().then((res)=>{
    let constObj = {}
    for(let one of res){
      if(one.baseDataName === 'MAX_UPLOAD_SIZE'){
        constants.MAX_UPLOAD_SIZE = Number(one.baseDataVal)
        constObj.MAX_UPLOAD_SIZE = Number(one.baseDataVal)
      }
      if(one.baseDataName === 'PAGE_SIZE'){
        constants.PAGE_SIZE = Number(one.baseDataVal)
        constObj.PAGE_SIZE = Number(one.baseDataVal)
      }
      if(one.baseDataName === 'IMAGE_TYPE'){
        constants.IMAGE_TYPE = one.baseDataVal.split('|')
        constObj.IMAGE_TYPE = one.baseDataVal.split('|')
      }
      if(one.baseDataName === 'CURRENCY'){
        constants.CURRENCY = one.baseDataVal
        constObj.CURRENCY = one.baseDataVal
      }
      if(one.baseDataName === 'BASEURL'){
        constants.BASEURL = one.baseDataVal
        constObj.BASEURL = one.baseDataVal
      }
      if(one.baseDataName === 'CANCELTIME'){
        constants.CANCELTIME = Number(one.baseDataVal)
        constObj.CANCELTIME = Number(one.baseDataVal)
      }
      if(one.baseDataName === 'REVIEWTIME'){
        constants.REVIEWTIME = Number(one.baseDataVal)
        constObj.REVIEWTIME = Number(one.baseDataVal)
      }
    }
    sessionStorage.setItem('const_obj',JSON.stringify(constObj))
  })
}

export {
  ConstantsPlugin,
  loadData,
  constants
}